/* eslint-disable no-shadow */
import axios from 'axios'
import { Notification } from 'element-ui'
import store from '@/store/index'
import Qs from 'qs'
import { getZjzwfwLegalLoginUrlSplice, getZjzwfwLoginUrlSplice } from '@/config'

/** 各环境接口请求baseUrl */
export const baseUrlMap = {
  testMicroApp: 'https://waftest.zjfcs.org.cn',
  prodMicroApp: 'https://loanh5.zjfcs.org.cn'
}

let baseURL = ''

if (process.env.NODE_ENV === 'production') {
  baseURL = (process.env.VUE_APP_BASE_ROUTER_URL || '')

  // 微应用使用的是浙里办的域名，如果走axios需要拼接完整的接口请求url
  if (process.env.VUE_APP_TYPE === 'microApp') {
    baseURL = baseUrlMap[process.env.VUE_APP_ENV]
  }
}

// 公共参数配置
const service = axios.create({
  baseURL,
  timeout: 40000,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
    // withCredentials: true
  },
  // 在向服务器发送前，修改请求数据，只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
  transformRequest: [
    data => {
      data = window.location.href.includes('blockChain') ? JSON.stringify(data) : Qs.stringify(data)
      return data
    }
  ]
  // 表示跨域请求时是否需要使用凭证
  // withCredentials: true
})

// 拦截请求
service.interceptors.request.use(
  config => {
    let ticket = store.state.user.ticket
    let token = store.state.user.token
    let ifmToken = store.state.user.ifmToken
    if (ticket) {
      // 法人
      config.headers['gxdjkey'] = ticket || ''
    } else if (token) {
      // 个人
      config.headers['gxdjpersonkey'] = token || ''
    }
    // 知识产权页所需用户票据
    if (sessionStorage.getItem('ssotickent')) {
      config.headers['ssotickent'] = sessionStorage.getItem('ssotickent') || ''
    }
    if (ifmToken) {
      config.headers['ifmToken'] = ifmToken || ''
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 拦截响应
// 在实例已创建后修改默认值
// 返回结果公共处理
service.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 400) {
      if (response.data.code === 1 && response.data.msg !== '参数不能为空') {
        Notification.error({ title: '提示', message: response.data.msg })
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  //  服务器状态码不是2开头的情况
  // 根据状态码进行一些操作
  error => {
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 402:
          // 登陆过期重定向
          Notification.error({ title: '提示', message: '未获取到登录态，请重新登录' })
          store.commit('user/SET_IS_TOKEN_EXPIRE', true)
          setTimeout(() => {
            // 经信厅的版本只有法人登录，直接跳到浙里办的法人登录界面
            if (process.env.VUE_APP_TARGET === 'jxt') {
              window.location.href = getZjzwfwLegalLoginUrlSplice()
            } else {
              window.location.href = getZjzwfwLoginUrlSplice()
            }
          }, 1000)
          break
        default:
          Notification.error({ title: '提示', message: '网络不稳定，请稍后重试' })
      }
      return Promise.reject(error.response)
    }
  }
)

export default service
